import Snackbar from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';
import MuiAlert from '@mui/material/Alert';
import { useEffect, useState, forwardRef } from 'react';

function TransitionUp(props) {
    return <Slide {...props} direction="up" />;
}

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
})

export default function EasySnackBar(props) {
    const [open, setOpen] = useState(false)
    const [msg, setMsg] = useState('')

    useEffect(() => {
        if (props.message !== '') {
            TransitionUp()
            setOpen(true)
            setMsg(props.message)
            props.setMessage('')
        }
    }, [props.message])

    return (
        <Snackbar
            open={open}
            onClose={() => setOpen(false)}
            TransitionComponent={TransitionUp}
        >
            <Alert onClose={() => setOpen(false)} severity={props.severity ? props.severity : ''} sx={{ width: '100%' }}>
                {msg}
            </Alert>
        </Snackbar>
    );
}